module.exports = __webpack_public_path__ + "assets/webgl/Assets_1_base_color.jpg.astc.77c0a95f.ktx";